import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface DefaultQuickSearchVsAISelectProps {
  value?: string | null;
  onChange(value: string | null): void;
}

export default function DefaultQuickSearchVsAISelect(props: DefaultQuickSearchVsAISelectProps): React.JSX.Element {
  const { i18n } = useTranslation();

  // Internal state to track current value, since we won't get updates when the preference changes
  const [internalValue, setInternalValue] = useState<string>(props.value === "on" ? "on" : "off");

  useEffect(() => {
    setInternalValue(props.value === "on" ? "on" : "off");
  }, [props.value]);

  function handleValueChange(event: SelectChangeEvent<string>): void {
    const newValue = event.target.value || null;
    const normalizedValue = newValue === "on" ? "on" : "off";

    // Update internal state, since we won't get an update when the preference changes
    setInternalValue(normalizedValue);

    props.onChange(normalizedValue);
  }

  return (
    <Select
      fullWidth
      variant="outlined"
      displayEmpty
      value={internalValue}
      onChange={handleValueChange}
    >
        <MenuItem key={"off"} value={"off"}>
          {i18n.t("profile-page.default-quicksearch-vs-ai-off")}
        </MenuItem>
        <MenuItem key={"on"} value={"on"}>
          {i18n.t("profile-page.default-quicksearch-vs-ai-on")}
        </MenuItem>
    </Select>
  )
}